export enum ButtonVariant {
  default = 'default',
  outlined = 'outlined',
  filled = 'filled',
  error = 'error',
  grey = 'grey',
  disabled = 'disabled',
  tabSelected = 'tab-selected',
  tab = 'tab',
}
